export interface XhprofCompactGraphCallExcludeList {
    [call: string]: true
}

export const defaultFoldingExcludeList: XhprofCompactGraphCallExcludeList = {
    // == Event dispatching code ==
    // CakePHP
    'CakeEventManager::dispatch': true,
    'Cake\\Event\\EventManager::dispatch': true,
    'Controller::invokeAction': true,
    'Cake\\Controller\\Controller::invokeAction': true,
    // Cake 2
    'Dispatcher::dispatch': true,
    // Cake 3
    'Cake\\Routing\\Dispatcher::dispatch': true,
    // Doctrine
    'Doctrine\\ORM\\UnitOfWork::computeChangeSets': true,
    'Doctrine\\ORM\\UnitOfWork::dispatchOnFlushEvent': true,
    'Doctrine\\ORM\\UnitOfWork::dispatchPostFlushEvent': true,
    'Doctrine\\ORM\\UnitOfWork::executeInserts': true,
    'Doctrine\\ORM\\UnitOfWork::executeUpdates': true,
    'Doctrine\\ORM\\UnitOfWork::executeDeletions': true,
    // drupal
    drupal_alter: true,
    drupal_deliver_page: true,
    // Flow
    'Neos\\Flow\\Http\\RequestHandler::boot': true,
    // webonyx/graphql-php
    'GraphQL\\Executor\\Executor::resolveOrError': true,
    // Laravel
    'Illuminate\\Events\\Dispatcher::dispatch': true,
    'Illuminate\\Events\\Dispatcher::fire': true,
    'Illuminate\\Foundation\\Http\\Kernel::bootstrap': true,
    'Illuminate\\Session\\Middleware\\StartSession::startSession': true,
    'Illuminate\\Session\\Middleware\\StartSession::collectGarbage': true,
    'Illuminate\\View\\Compilers\\BladeCompiler::compile': true,
    // Magento
    'Mage_Core_Model_App::dispatchEvent': true,
    'Magento\\Framework\\Event\\Manager::dispatch': true,
    'Magento\\Framework\\Event\\Invoker\\InvokerDefault::_callObserverMethod': true,
    'Mage_Core_Block_Abstract::toHtml': true,
    'Mage_Core_Model_App::_initModules': true,
    'Mage_Core_Model_Config::loadModules': true,
    'Mage_Core_Model_Config::loadDb': true,
    'Magento\\Framework\\View\\Element\\AbstractBlock::toHtml': true,
    'Magento\\Framework\\View\\Result\\Layout::renderResult': true,
    'Magento\\Framework\\App\\FrontController::dispatch': true,
    // Oxid 4 & 5
    'oxShopControl::_process': true,
    // Oxid 6
    'OxidEsales\\EshopCommunity\\Core\\ShopControl::_process': true,
    // Shopware
    'Shopware\\Core\\Kernel::boot': true,
    'Enlight_Event_EventManager::notify': true,
    'Enlight_Event_EventManager::notifyUntil': true,
    'Enlight_Event_EventManager::filter': true,
    'Shopware\\Kernel::boot': true,
    'Shopware\\Kernel::buildContainer': true,
    'Shopware\\Kernel::dumpContainer': true,
    // Smarty 2
    'Smarty::_smarty_include': true,
    'Smarty::fetch': true,
    // Smarty 3
    'Smarty_Internal_Template::_subTemplateRender': true,
    'Smarty_Internal_TemplateCompilerBase::compile': true,
    'Smarty_Internal_TemplateBase::fetch': true,
    'Smarty_Internal_TemplateBase::display': true,
    // Spryker
    'Spryker\\Shared\\Application\\Application::boot': true,
    // Symfony
    'Symfony\\Component\\EventDispatcher\\EventDispatcher::dispatch': true,
    'Symfony\\Component\\EventDispatcher\\Debug\\TraceableEventDispatcher::dispatch': true,
    'Symfony\\Component\\EventDispatcher\\Debug\\WrappedListener::__invoke': true,
    'Symfony\\Component\\HttpKernel\\Event\\FilterControllerEvent::__construct': true,
    'Symfony\\Component\\HttpKernel\\Event\\ControllerEvent::__construct': true,
    // Twig
    'Twig_Template::display': true,
    'Twig_Template::displayBlock': true,
    'Twig\\Template::display': true,
    'Twig\\Template::displayBlock': true,
    // WordPress
    'WP_Hook::do_action': true,
    'WP_Hook::apply_filters': true,
    // yii
    'yii\\base\\Component::trigger': true,
    'CComponent::raiseEvent': true,
    'yii\\base\\View::renderFile': true,
    'CBaseController::renderFile': true,
}
